import axios from "axios";
import { create } from "zustand";

const orderStore = create((set) => ({
  orderDetail: null,
  isLoading: true,

  orderFilterApply: 0,

  setOrderFilterApply: ({ value }) => {
    set({ orderFilterApply: value });
  },

  fetchAllOrders: async () => {
    try {
      // Fetch orders
      const res = await axios.get("/fetch-all-order");

      // set orders to state
      if (res.data.orderDetail.length) {
        set({ orderDetail: res.data.orderDetail });
      } else {
        set({ orderDetail: null });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },

  updateDeliveryStatus: async ({ paymentID, order_delivery_status }) => {
    try {
      set({ isLoading: true });
      const res = await axios.put(
        `/update-order-delivery-status/${paymentID}`,
        { order_delivery_status }
      );

      set({ orderDetail: res.data.orderDetail });
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
      set({ isLoading: false });
    }
  },

  updateOrderDeliveryStatusTimeIDForReturn: async ({
    _id,
    paymentID,
    orderDeliveryStatusTimeID,
  }) => {
    try {
      set({ isLoading: true });

      const res = await axios.put(
        `/update-order-delivery-status-time-id-for-return/${_id}`,
        { paymentID, orderDeliveryStatusTimeID }
      );

      set({ orderDetail: res.data.orderDetail });
      set({ isLoading: false });
    } catch (error) {
      set({ isLoading: false });
      console.log(error);
    }
  },
}));

export default orderStore;
